import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateSavedViewInput, SavedViewEntityType, SavedViewResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

function queryKey(entityType: SavedViewEntityType) {
  return ['saved-views', entityType];
}

export function useSavedViewsQuery(entityType: SavedViewEntityType) {
  return useQuery({
    queryKey: queryKey(entityType),
    queryFn: () => api.get<SavedViewResponse[]>(`/saved-views?entityType=${entityType}`),
  });
}

export function useCreateSavedView(entityType: SavedViewEntityType) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSavedViewInput) => api.post<SavedViewResponse>('/saved-views', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKey(entityType) }),
  });
}

export function useDeleteSavedView(entityType: SavedViewEntityType) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/saved-views/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKey(entityType) }),
  });
}
